
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from 'src/app/usuarioEsquema';
import { Usuario } from 'src/app/usuario';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';

@Injectable({
  providedIn: 'root'
})
export class VenimpfacturasService {

  private way: string;

  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');

  }

  validacedulas(arreglo) {

    return this.http.post<any[]>(this.way + '/ventas/venfacimp/faab26a98e6fa8000000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validavendedores(arreglo) {

    return this.http.post<any[]>(this.way + '/ventas/venfacimp/3eaac9aafbaed80000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validaencfac(arreglofac, arregloestabpuntoemi) {

    return this.http.post<any[]>(this.way + '/ventas/venfacimp/7d559355f75dd800000', {
      elementos: {
        arreglofac,
        arregloestabpuntoemi
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  getnemonicos(arregloestabpuntoemi) {

    return this.http.post<any[]>(this.way + '/ventas/venfacimp/83bb775b1793300', {
      elementos: {
        arregloestabpuntoemi
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  procesarfacturas(item) {
    return this.http.post<any[]>(this.way + '/ventas/venfacimp/cef0c7715b7a98000000', {
      elementos: {
        p_RUC_CEDULA :item.RUC_CEDULA ,
        p_RAZON_SOCIAL :item.RAZON_SOCIAL ,
        p_ESTABLECIMIENTO :item.ESTABLECIMIENTO ,
        p_PUNTO_EMISION :item.PUNTO_EMISION ,
        p_NUMERO :item.NUMERO ,
        p_COMENTARIO :item.COMENTARIO  ,
        p_ESTUDIANTE :item.ESTUDIANTE ,
        p_CEDULA_ESTUDIANTE :item.CEDULA_ESTUDIANTE ,
        p_CODIGO_ESTUDIANTE :item.CODIGO_ESTUDIANTE ,
        p_COD_SERVICIO :item.COD_SERVICIO ,
        p_CONCEPTO :item.CONCEPTO ,
        p_NOMBRE_GRUPO :item.NOMBRE_GRUPO ,
        p_COD_GRUPO :item.COD_GRUPO ,
        p_COD_VENDEDOR :item.COD_VENDEDOR ,
        p_FECHA :item.FECHA ,
        p_SUBTOTAL :Number(item.SUBTOTAL)  ,
        p_DESCUENTO :Number(item.DESCUENTO) ,
        p_VALOR_IVA :Number(item.VALOR_IVA) ,
        p_TOTAL :Number(item.TOTAL ),
        p_ESTADO :item.ESTADO ,
        p_DIRECCION :item.DIRECCION ,
        p_CORREO :item.CORREO ,
        p_TELEFONO :item.TELEFONO  ,
        p_ENCFAC_NUMERO :item.ENCFAC_NUMERO ,
        p_cencod:item.CENTRO_COSTOS,
        p_usu_identificacion :this.usuario.identificacion 
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validaservicios(arreglo) {
    return this.http.post<any[]>(this.way + '/ventas/venfacimp/7d559355c76ff400000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
  validacencostos(arreglo) {
    return this.http.post<any[]>(this.way + '/ventas/venfacimp/7d559354c75d9800000', {
      elementos: {
        arreglo
      },
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
